import React, { useState } from 'react';
import { mockGSTVendors, formatCurrency } from '../../../services/mockData';

const GSTVendors = () => {
  const [type, setType] = useState('both');

  return (
    <div className="fade-in">
      <div className="page-header">
        <div className="breadcrumb">Gst Reports <span>/ Sales/Purchases</span></div>
        <h2>GSTR - Vendors</h2>
      </div>

      <div className="filter-bar">
        <div className="form-group">
          <label>Vendors</label>
          <select className="form-control">
            <option>All</option>
            <option>Mahesh CCTV Company Pvt Ltd</option>
          </select>
        </div>
        <div className="form-group">
          <label>Select Type</label>
          <select className="form-control" value={type} onChange={e => setType(e.target.value)}>
            <option value="both">Both</option>
            <option value="sales">Sales</option>
            <option value="purchases">Purchases</option>
          </select>
        </div>
        <div className="form-group">
          <label>From Date</label>
          <input type="text" className="form-control" defaultValue="01-04-2025" />
        </div>
        <div className="form-group">
          <label>To Date</label>
          <input type="text" className="form-control" defaultValue="01-02-2026" />
        </div>
        <div className="form-group" style={{ justifyContent: 'flex-end', marginLeft: 'auto' }}>
          <div className="btn-group">
            <button className="btn btn-primary">🔍 Search</button>
            <button className="btn btn-success btn-sm">📊 Export To Excel</button>
          </div>
        </div>
      </div>

      <div className="card">
        <div className="report-header" style={{ marginBottom: '16px' }}>
          <h3>Vitthal Plaza Co-Op Housing Society LTD</h3>
          <p>TNADO(M/HSG/TC)/25796/YEAR-2023 | dr Sagar(Dombivali)</p>
          <p style={{ fontWeight: '700', marginTop: '6px' }}>
            GSTR Sales/Purchases Financial Year: 2025-2026<br />
            Period From 01-04-2025 To 02-02-2026<br />
            GST charged(Sale) as under:
          </p>
        </div>

        <div className="table-wrapper">
          <table>
            <thead>
              <tr>
                <th>GSTIN</th>
                <th>Particulars</th>
                <th>Invoice No</th>
                <th>Invoice Date</th>
                <th className="amount">Total Invoice Value</th>
                <th className="amount">Taxable Invoice (₹)</th>
                <th className="amount">Intergrated Tax (₹)</th>
                <th className="amount">Central Tax (₹)</th>
                <th className="amount">State/UT Tax (₹)</th>
                <th className="amount">Total Tax (₹)</th>
              </tr>
            </thead>
            <tbody>
              {mockGSTVendors.map((v, i) => (
                <tr key={i}>
                  <td>{v.gstin || '—'}</td>
                  <td style={{ fontWeight: '600' }}>{v.particulars}</td>
                  <td>{v.invoiceNo}</td>
                  <td>{v.invoiceDate}</td>
                  <td className="amount">{formatCurrency(v.totalInvoice)}</td>
                  <td className="amount">{formatCurrency(v.taxableValue)}</td>
                  <td className="amount">{formatCurrency(v.igstTax)}</td>
                  <td className="amount cr">{formatCurrency(v.cgstTax)}</td>
                  <td className="amount cr">{formatCurrency(v.sgstTax)}</td>
                  <td className="amount" style={{ fontWeight: '700' }}>{formatCurrency(v.totalTax)}</td>
                </tr>
              ))}
            </tbody>
            <tfoot>
              <tr>
                <td colSpan={4} style={{ textAlign: 'right', fontWeight: '800' }}>Total</td>
                <td className="amount">{formatCurrency(mockGSTVendors.reduce((s, v) => s + v.totalInvoice, 0))}</td>
                <td className="amount">{formatCurrency(mockGSTVendors.reduce((s, v) => s + v.taxableValue, 0))}</td>
                <td className="amount">0.00</td>
                <td className="amount cr">{formatCurrency(mockGSTVendors.reduce((s, v) => s + v.cgstTax, 0))}</td>
                <td className="amount cr">{formatCurrency(mockGSTVendors.reduce((s, v) => s + v.sgstTax, 0))}</td>
                <td className="amount" style={{ fontWeight: '800' }}>{formatCurrency(mockGSTVendors.reduce((s, v) => s + v.totalTax, 0))}</td>
              </tr>
            </tfoot>
          </table>
        </div>
      </div>
    </div>
  );
};

export default GSTVendors;
